<div [class]="envClass" class="note-window">
  <mat-toolbar class="custom-toolbar">
    <span>{{note.title}}</span>
    <span class="spacer"></span>
    <div class="action-buttons">
      <button mat-icon-button (click)="addTask()" title="Task toevoegen">
        <mat-icon>add_task</mat-icon>
      </button>
      <button mat-icon-button (click)="save()" title="Opslaan">
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div class="editor-content-area">
    <div class="document-paper">
      <!-- Custom Toolbar -->
      <div class="ck-style-toolbar" *ngIf="editor">

        <!-- Heading Selector -->
        <div class="toolbar-group">
          <select (change)="onHeadingChange($event)" class="heading-select">
            <option value="p" [selected]="editor.isActive('paragraph')">Paragraph</option>
            <option value="1" [selected]="editor.isActive('heading', { level: 1 })">Heading 1</option>
            <option value="2" [selected]="editor.isActive('heading', { level: 2 })">Heading 2</option>
            <option value="3" [selected]="editor.isActive('heading', { level: 3 })">Heading 3</option>
          </select>
        </div>

        <div class="divider"></div>

        <!-- Formatting: Bold, Italic, Link, Code -->
        <div class="toolbar-group">
          <button type="button" (click)="editor.chain().focus().toggleBold().run()"
            [class.active]="editor.isActive('bold')" title="Bold">
            <mat-icon>format_bold</mat-icon>
          </button>
          <button type="button" (click)="editor.chain().focus().toggleItalic().run()"
            [class.active]="editor.isActive('italic')" title="Italic">
            <mat-icon>format_italic</mat-icon>
          </button>
        </div>

        <div class="divider"></div>

        <!-- Lists -->
        <div class="toolbar-group">
          <button type="button" (click)="editor.chain().focus().toggleBulletList().run()"
            [class.active]="editor.isActive('bulletList')" title="Bullet List">
            <mat-icon>format_list_bulleted</mat-icon>
          </button>
          <button type="button" (click)="editor.chain().focus().toggleOrderedList().run()"
            [class.active]="editor.isActive('orderedList')" title="Numbered List">
            <mat-icon>format_list_numbered</mat-icon>
          </button>
        </div>

        <div class="divider"></div>

        <!-- Alignment -->
        <div class="toolbar-group">
          <button type="button" (click)="editor.chain().focus().setTextAlign('left').run()"
            [class.active]="editor.isActive({ textAlign: 'left' })" title="Align Left">
            <mat-icon>format_align_left</mat-icon>
          </button>
          <button type="button" (click)="editor.chain().focus().setTextAlign('right').run()"
            [class.active]="editor.isActive({ textAlign: 'right' })" title="Align Right">
            <mat-icon>format_align_right</mat-icon>
          </button>
        </div>

        <div class="divider"></div>

        <!-- Tables, Quotes, Codeblock -->
        <div class="toolbar-group">
          <button type="button" (click)="editor.chain().focus().toggleBlockquote().run()"
            [class.active]="editor.isActive('blockquote')" title="Blockquote">
            <mat-icon>format_quote</mat-icon>
          </button>
          <button type="button" (click)="editor.chain().focus().toggleCodeBlock().run()"
            [class.active]="editor.isActive('codeBlock')" title="Code Block">
            <mat-icon>integration_instructions</mat-icon>
          </button>
        </div>

        <div class="divider"></div>

        <!-- Undo & Redo -->
        <div class="toolbar-group">
          <button type="button" (click)="editor.chain().focus().undo().run()" [disabled]="!editor.can().undo()"
            title="Undo">
            <mat-icon>undo</mat-icon>
          </button>
          <button type="button" (click)="editor.chain().focus().redo().run()" [disabled]="!editor.can().redo()"
            title="Redo">
            <mat-icon>redo</mat-icon>
          </button>
        </div>

        <div class="divider"></div>

        <!-- Media: Image -->
        <div class="toolbar-group">
          <button type="button" (click)="addImage()" title="Insert Image">
            <mat-icon>image</mat-icon>
          </button>
        </div>

      </div>
      <div #editorElement class="tiptap-editor-content"></div>

    </div>
  </div>
</div>